import React from 'react';
import { ElevesSidebar } from 'containers/Livrets/LivretEval/LivretEleve/ElevesSidebar';
import 'twin.macro';
import { NarrowContainer } from 'components/Container';
import {
  LivretEleve,
  LivretEval,
  Periode,
} from 'containers/Livrets/types/livret';
import { Eleve } from 'types/eleves';
import { Bo } from 'types/bo';
import { useOutletContext, useParams } from 'react-router-dom';
import { Contact, School } from 'types/school';
import { Schoolyear } from 'types/schoolyear';
import { Classroom } from 'types/classroom';
import { useGetQuerySort } from 'containers/Livrets/LivretEval/useGetQuerySort';
import _orderBy from 'lodash-es/orderBy';
import { TryTeetshHeader } from 'components/TryTeetshHeader';
import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from 'components/Resizable';
import { LivretEleveRoot } from 'containers/Livrets/LivretEval/LivretEleve/LivretEleveRoot';

export function LivretEleveShare() {
  const context = useOutletContext<{
    school: School;
    schoolyear: Schoolyear;
    livretEval: LivretEval;
    periodes: Periode[];
    directors: Contact[];
    classroom: Classroom;
    eleves: Eleve[];
    bo: Bo;
    userId: string;
    token: string;
    readonly: boolean;
  }>();
  const params = useParams<{
    eleveId: string;
  }>();
  const eleveId = params?.eleveId as string;
  const { desc, sortField } = useGetQuerySort();
  return (
    <div tw="flex h-screen">
      <ResizablePanelGroup
        direction="horizontal"
        autoSaveId="livret-share-eleve-sidebar"
      >
        <ElevesSidebar
          getEleveLink={elvId =>
            `/shares/${context.userId}/t/${context.token}/livrets/eleves/${elvId}`
          }
          backLink={`/shares/${context.userId}/t/${context.token}/livrets/`}
          livretEvalId={context?.livretEval?.id}
          eleves={_orderBy<Eleve>(
            context.eleves,
            [sortField || 'familyName'],
            [desc ? 'desc' : 'asc'],
          )
            .filter(ev => ev.classroomId === context.livretEval.classroomId)
            .map(ev => {
              const livretEv = context.livretEval.livretsEleves.find(
                le => le.eleveId === ev.id,
              );
              return {
                livretStatus: livretEv?.status || 'not_started',
                picture: ev.picture,
                id: ev.id,
                givenName: ev.givenName,
                familyName: ev.familyName,
                fullName: `${ev.familyName} ${ev.givenName}`,
              };
            })}
          current={eleveId}
        />
        <ResizableHandle />
        <ResizablePanel order={1}>
          <div tw="flex flex-col h-full">
            <TryTeetshHeader utmCampaign="share_livret_eleve" hideOnMobile />
            {/* Le py-0 c'est à cause du bandeau TryTeetsh */}
            <NarrowContainer
              width="5xl"
              tw="min-h-0 flex-1 overflow-y-auto w-full pb-12"
            >
              <LivretEleveRoot
                withIA={false}
                readonly={context?.readonly as boolean}
                livretEleve={
                  context?.livretEval?.livretsEleves.find(
                    ev => ev.eleveId === eleveId,
                  ) as LivretEleve
                }
                eleve={context?.eleves.find(ev => ev.id === eleveId) as Eleve}
                livretEval={context?.livretEval as LivretEval}
                periodes={context?.periodes || []}
                directors={context?.directors || []}
                bo={context?.bo as Bo}
                loadingDirectors={false}
                backLink={`/shares/${context.userId}/t/${context.token}/livrets/`}
              />
            </NarrowContainer>
          </div>
        </ResizablePanel>
      </ResizablePanelGroup>
    </div>
  );
}
